import { common, educationStyles } from "./styles"
import { useAuth } from "../../AuthContext"
import { useNavigate } from "react-router-dom"
import axios from "axios"

// Accept profile as a prop
export default function Education({ profile }) {
  const { user } = useAuth()
  const navigate = useNavigate()
  const education = profile?.education || []
  const isOwner = user && profile && user.id === profile.user_id

  const handleEditEducation = (edu) => {
    navigate("/AddEducation", { state: { educationRecord: edu } })
  }

  const handleRemoveEducation = async (educationId) => {
    if (!window.confirm("Are you sure you want to remove this education record?")) return
    try {
      await axios.delete(`http://localhost:5000/delete-education/${educationId}`)
      navigate(`/ProProject`);
    } catch (err) {
      alert("Failed to remove education record")
    }
  }

  return (
    <section style={common.section} id="education">
      <div style={common.sectionContent}>
        <h2
          style={{
            fontSize: "3rem",
            fontFamily: common.subheading.fontFamily,
            fontWeight: 700,
            textTransform: "uppercase",
            color: "#343a40",
            marginBottom: "2rem",
          }}
        >
          Education
        </h2>

        {education.length === 0 && <div>No education records found.</div>}

        {education.map((edu, index) => (
          <div key={index} style={educationStyles.item}>
            <div style={{ marginBottom: "1rem" }}>
              <h3 style={educationStyles.school}>
                {edu.degree} in {edu.field_of_study}
              </h3>
              <div style={educationStyles.degree}>{edu.institution_name}</div>
              <p>{edu.notes}</p>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={educationStyles.period}>
                {edu.start_date} - {edu.end_date}
              </span>
              {isOwner && (
                <div style={{ marginLeft: "1rem", display: "flex", gap: "0.5rem" }}>
                  <button
                    onClick={() => handleEditEducation(edu)}
                    title="Edit"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.1rem",
                      padding: 0,
                    }}
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleRemoveEducation(edu.education_id)}
                    title="Remove"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.1rem",
                      padding: 0,
                    }}
                  >
                    ❌
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
